export default __webpack_public_path__ + "static/Icono-ahorro-en-agua-2c65c498acca2ac157ec0998f8c38a58.png";